import getColor from "@insite/mobius/utilities/getColor";
import { currencyMenuStyles as styles } from "@solveindustrial/Overrides/Widgets/Common/CurrencyMenu";
import { colorStrings } from "@solveindustrial/Utilities/variables";
import { css } from "styled-components";

styles.currencySymbol = {
    ...styles.currencySymbol,
    color: colorStrings.primaryMain,
    weight: 400,
    css: css`
        margin-top: 0;
    `,
};

styles.currencySelect = {
    ...styles.currencySelect,
    backgroundColor: "transparent",
    border: undefined,
    mergeCss: true,
    iconProps: {
        color: colorStrings.primaryMain,
    },
    cssOverrides: {
        inputSelect: css`
            color: ${getColor(colorStrings.commonGlobalGray01)};
            border: 0;
        `,

        formInputWrapper: css`
            ${styles.currencySelect?.cssOverrides?.formInputWrapper}
            width: 80px;
            span {
                width: 36px !important;
                height: 46px !important;
                min-height: 46px !important;
            }
        `,
    },
};

styles.currencyWrapper = {
    ...styles.currencyWrapper,
    css: css`
        ${styles.currencyWrapper?.css}
        align-items: center;
    `,
};

styles.currencyCode = {
    ...styles.currencyCode,
    weight: 700,
    css: css`
        margin-left: 5px;
        font-size: 18px;
    `,
};
